import { CHANGELOG } from './changelog'

// Fonte única da verdade: a versão exibida (badge da Sidebar, rodapés de login)
// deriva da entrada mais recente do changelog. Basta adicionar uma nova entrada
// no topo de changelog.ts a cada release — o badge atualiza junto.
export const APP_VERSION = CHANGELOG[0]?.version ?? '0.0.0'
